import { clsx } from "clsx";

const palette = {
  primary: {
    lighter: "#7dd3fc",
    darker: "#0369a1",
  },
  secondary: {
    lighter: "#7dd3fc",
    darker: "#0369a1",
  },
};

export const GlowBg = ({
  className,
  variant = "primary",
}: {
  className?: string;
  variant?: "primary" | "secondary";
}) => {
  const stopColor =
    variant === "primary"
      ? palette.primary.lighter
      : palette.secondary.lighter;
  const stopColorTwo =
    variant === "primary" ? palette.primary.darker : palette.secondary.darker;

  return (
    <svg
      viewBox="0 0 1024 1024"
      aria-hidden="true"
      className={clsx(className, "absolute -z-10")}
    >
      <circle
        cx="512"
        cy="512"
        r="512"
        fill={`url(#gradient-${variant})`}
        fillOpacity="0.7"
      ></circle>
      <defs>
        <radialGradient
          id={`gradient-${variant}`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(512 512) rotate(90) scale(512)"
        >
          <stop stopColor={stopColor} stopOpacity="0.5"></stop>
          <stop offset="1" stopColor={stopColorTwo} stopOpacity="0"></stop>
        </radialGradient>
      </defs>
    </svg>
  );
};
